const VIEW_MODES = {
	EDIT  : 'edit',
	CREATE : 'create',
	READ :  'read'
};

export default class ViewModes {

	static get EDIT() {
		return VIEW_MODES.EDIT;
	}

	static get CREATE() {
		return VIEW_MODES.CREATE;
	}

	static get READ() {
		return VIEW_MODES.READ;
	}

	static get List() {
		return _.cloneDeep(VIEW_MODES);
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/enums/view-modes.types.js